export default __webpack_public_path__ + "static/media/fj.f65f8e1a.svg";